<template>
  <div>
    <modal-loading
      :openModal="isLoading"
      :value="'100'"
      :label="'carregando... '"
      :variant="'white'"
      :animated="false"
    >
    </modal-loading>

    <div class="product-details-obscurator fade-obscurator">
      <div class="product-details-sidebar">
        <div class="edit-header d-flex">
          <div class="w-100 text-default">
            <!-- {{ product.vendor_name ? product.vendor_name : product.product_place_name }} -->
            <strong> Editar {{ product.type?product.type.value:'Item' }}</strong>
            <br />
            <span class="w-100">
              {{ product.vendor_name ? (product.product_place_name ? product.product_place_name.value : '') : '' }}
              -
              {{ product.product_name ? product.product_name.value : '' }}
            </span>
          </div>
        </div>
        <button
          style="position: absolute; top: 30px; right: 40px"
          @click.prevent="closeEditProductPanel()"
          type="button"
          aria-label="Close"
          class="close"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 1.5L16.5 16.5"
              stroke="#8D8D8D"
              stroke-width="3"
              stroke-linecap="round"
            />
            <path
              d="M16.5 1.5L1.5 16.5"
              stroke="#8D8D8D"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
        </button>

        <div class="product-details-body">
          <div class="product-summary">
            <div class="product-summary-media">
              <img
                v-if="resolvedCoverUrl"
                class="product-summary-cover"
                :src="resolvedCoverUrl"
                :alt="product.product_name || 'Imagem do atrativo'"
              />
              <div v-else class="product-summary-cover-placeholder">
                <span v-if="!product.cover || product.cover.value == ''">
                  sem imagem de capa
                  </span>
                <span v-else>
                  carregando...
                </span>
              </div>
              <img
                v-if="resolvedLogoUrl"
                class="product-summary-logo"
                :src="resolvedLogoUrl"
                alt="Logo do atrativo"
              />
            </div>

            <p v-if="truncatedDescription" class="product-summary-description">
            </p>

            <div v-if="formattedPrice" class="product-summary-price">
            </div>
          </div>
          <div class="steps-choice mt-4">
            <!-- -->
            <section v-for="step in steps" :key="step.id" class="step mt-3">
              <div
                @click="openEditXFieldModal(step.page_id, 1)"
                :title="`Editar ${step.page_title}`"
                type="button"
                class="step-header"
              >
                <div class="step-info">
                  <span style="font-size: 18px">
                    {{ step.page_title || step.public_label }}
                    <small class="text-muted"
                      >({{ step.configured.empty }} /
                      {{ step.configured.total }})</small
                    >
                  </span>
                  <p v-if="step.page_subtitle">{{ step.page_subtitle }}</p>
                </div>

                <!-- <div
                  class="step-action"
                  @click.stop="openStep = openStep === step.id ? null : step.id"
                >
                  <span>{{
                    openStep === step.id ? 'ocultar campos' : 'ver campos'
                  }}</span>

                  <span
                    class="chevron"
                    :class="{ rotated: openStep === step.id }"
                  >
                    ⌄
                  </span>
                </div> -->
              </div>

              <div v-if="openStep === step.id" class="step-body">
                <!-- conteúdo específico da etapa -->
              </div>
            </section>
          </div>
        </div>

        <div class="product-details-footer">
          <button
            class="btn btn-primary w-50"
            style="margin-left: 10px"
            @click="openEditXFieldModal('product_name', 'iniciar')"
            title="Editar atrativo"
            type="button"
          >
            {{ 'Editar atrativo' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import { formatNumberToBRL } from '@/helpers/formaters'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import nodeService from '@/services/nodejs'
import { fetchFileObjectUrl } from '@/store/utils/publicLogoFile'

export default {
  name: 'EditProductPanel',
  components: {
    ModalLoading,
  },
  props: {
    xFields: {
      type: Object,
      default: {},
    },
    product: {
      type: Object,
      default: {},
    },
    isOpeningEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      currentXField: null,
      coreObject: 'Product',

      openStep: null,

      /* controla etapas */
      steps: [],
      coverObjectUrl: null,
      logoObjectUrl: null,
      resolvedCoverUrl: null,
      resolvedLogoUrl: null,
    }
  },
  computed: {
    coverUrl() {
      return this.resolveMediaUrl(this.product.cover)
    },
    logoUrl() {
      return this.resolveMediaUrl(this.product.location_logo)
    },
    truncatedDescription() {
      const text = this.stripHtml(this.product.description)
      if (!text) return ''
      if (text.length <= 200) return text
      return `${text.slice(0, 200).trim()}...`
    },
    formattedPrice() {
      const raw = this.product.activity_price
      if (raw === '' || raw === null || raw === undefined) return ''
      const price = Number(raw)
      if (!Number.isFinite(price)) return ''
      return formatNumberToBRL(price)
    },
  },
  methods: {
    closeEditProductPanel() {
      this.unlockBodyScroll()
      this.$emit('closeEditProductPanel')
    },
    lockBodyScroll() {
      this._previousBodyOverflow = document.body.style.overflow
      this._previousHtmlOverflow = document.documentElement.style.overflow
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    },
    unlockBodyScroll() {
      document.body.style.overflow =
        this._previousBodyOverflow != null ? this._previousBodyOverflow : ''
      document.documentElement.style.overflow =
        this._previousHtmlOverflow != null ? this._previousHtmlOverflow : ''
    },
    stripHtml(value) {
      if (!value) return ''
      const tmp = document.createElement('div')
      tmp.innerHTML = String(value)
      return (tmp.textContent || tmp.innerText || '')
        .replace(/\s+/g, ' ')
        .trim()
    },
    resolveMediaUrl(value) {
      if (!value) return ''

      let url = value
      if (Array.isArray(value)) {
        url = value[0]
      }
      if (url && typeof url === 'object') {
        url = url.url || url.src || url.filepath || url.value || ''
      }
      if (typeof url !== 'string' || !url.trim()) return ''
      if (url.indexOf('google.com') > 0) {
        const match = /d\/([^/]+)\/view/.exec(url)
        if (match && match[1]) {
          return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w800`
        }
      }

      return url
    },
    isDirectMediaUrl(value) {
      if (!value || typeof value !== 'string') return false
      return (
        value.indexOf('http://') === 0 ||
        value.indexOf('https://') === 0 ||
        value.indexOf('blob:') === 0 ||
        value.indexOf('data:image') === 0
      )
    },
    clearCoverObjectUrl() {
      if (this.coverObjectUrl) {
        URL.revokeObjectURL(this.coverObjectUrl)
        this.coverObjectUrl = null
      }
    },
    clearLogoObjectUrl() {
      if (this.logoObjectUrl) {
        URL.revokeObjectURL(this.logoObjectUrl)
        this.logoObjectUrl = null
      }
    },
    async loadProductMedia() {
      await Promise.all([this.loadCoverMedia(), this.loadLogoMedia()])
    },
    async loadCoverMedia() {
      this.clearCoverObjectUrl()
      this.resolvedCoverUrl = null

      const source = this.coverUrl
      if (!source) return

      if (this.isDirectMediaUrl(source)) {
        this.resolvedCoverUrl = source
        return
      }

      try {
        const objectUrl = await fetchFileObjectUrl(source)
        if (!objectUrl) return
        this.coverObjectUrl = objectUrl
        this.resolvedCoverUrl = objectUrl
      } catch (error) {
        console.warn('Não foi possível carregar a capa do atrativo:', error)
      }
    },
    async loadLogoMedia() {
      this.clearLogoObjectUrl()
      this.resolvedLogoUrl = null

      const source = this.logoUrl
      if (!source) return

      if (this.isDirectMediaUrl(source)) {
        this.resolvedLogoUrl = source
        return
      }

      try {
        const response = await nodeService.getFileByPath(source)
        const objectUrl = URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        )
        this.logoObjectUrl = objectUrl
        this.resolvedLogoUrl = objectUrl
      } catch (error) {
        console.warn('Não foi possível carregar o logo do atrativo:', error)
      }
    },
    openEditXFieldModal(xfield, target) {
      if (this.isOpeningEdit) {
        return
      }
      let productUuid = this.product.uuid || this.product.product_uuid
      productUuid = productUuid.value || productUuid
      this.isLoading = true
      this.currentXField = xfield
      this.currentStep = target || 'iniciar'
      this.$emit('openEditXFieldModal', {
        object_uuid: productUuid,
        coreObject: this.coreObject, //Product, Agent, Place, Service
        currentXField: this.currentXField, //product_name, category, session_1, session_2, etc
        currentStep: this.currentStep, //page_1, page_2, etc
      })
    },
  },
  async mounted() {

    Object.values(this.xFields).forEach((xField) => {
      if (xField.label.indexOf('page_') === 0) {
        let step = {
          id: xField.id,
          page_id: xField.label,
          public_label: xField.public_label,
          page_title: '',
          page_subtitle: '',
          configured: { empty: 0, total: 0 },
        }
        let parsedOption = Object.keys(xField.options)[0].split('#')
        step.page_title = parsedOption[1]
          ? parsedOption[0]
          : 'Página ' + xField.label.split('_')[1]
        if (parsedOption.length > 0) {
          parsedOption = parsedOption[1] || parsedOption[0]
          parsedOption = parsedOption.replace(/'[^']*'/g, (match) =>
            match.replace(';', ',')
          )
          parsedOption = parsedOption.replace(/\(([^()]*)\)/g, (match) =>
            match.replace(/;/g, ',')
          )

          parsedOption = parsedOption.split(';')

          parsedOption.forEach((item) => {
            item = item.split('=')
            let key = item[0]
            let val = item[1] || ''
            if (key !== 'icon') {
              val = val.replaceAll('_ ', ': ')
            }
            step[key] = val.replaceAll("'", '')
          })
        }
        this.steps.push(step)
      } else {
        if (Number(xField.add_display) == 1) {
          this.steps[this.steps.length - 1].configured.total++
          if (!this.product[xField.label]) {
            // this.steps[this.steps.length - 1].configured.total++
            this.steps[this.steps.length - 1].configured.empty++
          } else {
            if (
              Object.prototype.toString.call(this.product[xField.label]) ===
                '[object Array]' &&
              this.product[xField.label].length == 0
            ) {
              this.steps[this.steps.length - 1].configured.empty++
            }
            if (
              Object.prototype.toString.call(this.product[xField.label]) ===
                '[object Object]' &&
              Object.keys(this.product[xField.label]).length == 0
            ) {
              this.steps[this.steps.length - 1].configured.empty++
            }
            if (
              this.product[xField.label] &&
              this.product[xField.label] == ''
            ) {
              this.steps[this.steps.length - 1].configured.empty++
            }
          }
        }
      }
    })
    this.lockBodyScroll()
    await this.loadProductMedia()
  },
  beforeDestroy() {
    this.clearCoverObjectUrl()
    this.clearLogoObjectUrl()
    this.unlockBodyScroll()
  },
  watch: {
    product: {
      deep: true,
      handler() {
        this.loadProductMedia()
      },
    },
  },
}
</script>

<style>
.product-summary {
  margin-bottom: 8px;
}

.product-summary-media {
  position: relative;
  width: 100%;
  height: 220px;
  border-radius: 12px;
  overflow: hidden;
  background: #eef2f4;
  margin-bottom: 16px;
}

.product-summary-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.product-summary-cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a8a8a;
  font-size: 14px;
}

.product-summary-logo {
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: 72px;
  height: 72px;
  object-fit: contain;
  background: #fff;
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}

.product-summary-description {
  margin: 0 0 10px;
  color: #555;
  line-height: 1.5;
}

.product-summary-price {
  margin: 0 0 4px;
  color: #12576e;
  font-size: 22px;
  font-weight: 700;
}

.steps {
  width: 100%;
}

.steps > h1 {
  margin-bottom: 32px;
  font-size: 20px;
  font-weight: 400;
}

.step {
  margin-bottom: 26px;
  border: 1px solid #bdbdbd;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.step:hover {
  border-color: #006b8a;
}

.step-header {
  width: 100%;
  padding: 15px 20px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  cursor: pointer;
}

.step-info span {
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: 500;
}

.step-info p {
  margin: 0;
  font-size: 17px;
  color: #666;
}

.step-action {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #006b8a;
  white-space: nowrap;
  border: 1px solid #006b8a;
  padding: 5px 10px;
  border-radius: 5px;
}

.chevron {
  font-size: 34px;
  line-height: 0;
  transition: transform 0.2s ease;
  margin-bottom: 15px;
}

.chevron.rotated {
  transform: rotate(180deg);
  transform-origin: center center;
  margin-bottom: -15px;
}

.step-body {
  padding: 0 48px 40px;
  border-top: 1px solid #eee;
}

.fade-obscurator {
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
